<template>
  <section class="viewswxredirectPage_index"></section>
</template>

<script>
export default {
  props: [""],

  data() {
    return {};
  },

  computed: {},

  watch: {},

  components: {},

  mixins: [],

  beforeCreate() {},

  created() {
    window.location.replace(decodeURIComponent(this.$route.query.redirect_url));
  },

  beforeMount() {},

  mounted() {},

  activated() {},

  deactivated() {},

  methods: {}
};
</script>
<style lang="less" scoped>
.viewswxredirectPage_index {
}
</style>
<style lang="less">
.viewswxredirectPage_index {
}
</style>
